import { captureMessage } from "@sentry/react";
import transformRes from "../utils/Storage/transformRes";

class SessionStorageService {
  public static getItem(key: string) {
    if (typeof window !== "undefined") {
      const res = window.sessionStorage.getItem(key);
      return res ? transformRes(res) : null;
    } else {
      captureMessage("getItem (ls): window not found");
      return null;
    }
  }

  public static setItem(key: string, value: any) {
    if (typeof window !== "undefined") {
      window.sessionStorage.setItem(key, value);
    } else {
      captureMessage("setItem (ls): window not found");
    }
  }

  public static removeItem(key: string) {
    if (typeof window !== "undefined") {
      window.sessionStorage.removeItem(key);
    } else {
      captureMessage("removeItem (ls): window not found");
    }
  }

  public static clear() {
    if (typeof window !== "undefined") {
      window.sessionStorage.clear();
    } else {
      captureMessage("clear (ls): window not found");
    }
  }
}

export default SessionStorageService;
